import React from "react";

const HowItWorks = () => {
	return (
		<div className="lg-xl:mt-20 lg:mt-15 mt-10">
			<div className="bg-customRed lg-xl:py-20 lg:py-15 py-10">
				<div className="w-full px-20px max-w-[1336px] mx-auto">
					<div className="flex justify-center">
						<h2 className="text-white font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-customRed tracking-normal uppercase font-fira pb-20px">
							How It Works
						</h2>
					</div>
					<div className="flex flex-col md:flex-row justify-between lg-xl:gap-[10px] gap-2">
						{/* Card 1 - Using h-full to ensure full height */}
						<div className="bg-white rounded-[16px] lg-xl:p-30px p-5 text-center md:w-[33.33%] w-full md:max-w-[33.33%] max-w-full flex flex-col items-center">
							<div className="pb-20px">
								<img src="/lists.png" alt="Lists" />
							</div>
							<p className="lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal">
								Create your personal network list in your password-protected Fired Up To Vote account.
							</p>
						</div>

						<div className="block text-white self-center md:rotate-0 rotate-90 md:py-0 py-2 md:w-[38px] md:h-[25.5px]">
							<img src="/back_arrow.svg"  alt="back_arrow" className="" />
						</div>

						{/* Card 2 - Using h-full to ensure full height */}
						<div className="bg-white rounded-[16px] lg-xl:p-30px p-5 text-center md:w-[33.33%] w-full md:max-w-[33.33%] max-w-full flex flex-col items-center">
							<div className="pb-20px">
								<img src="/mobilechat.png" alt="Mobile chat" />
							</div>
							<p className="lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal">
								Share email/text templates containing essential election information with your personal network list before and during Early Voting.
							</p>
						</div>

						<div className="block text-white self-center md:rotate-0 rotate-90 md:py-0 py-2 md:w-[38px] md:h-[25.5px]">
							<img src="/back_arrow.svg"  alt="back_arrow" className="" />
						</div>

						{/* Card 3 - Using h-full to ensure full height */}
						<div className="bg-white rounded-[16px] lg-xl:p-30px p-5 text-center md:w-[33.33%] w-full md:max-w-[33.33%] max-w-full flex flex-col items-center">
							<div className="pb-20px">
								<img src="/laptop.png" alt="Laptop" />
							</div>
							<p className="lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal">
								Check your account regularly during Early Voting and before Election Day to see who in your network has voted. Contact those who have not voted to encourage them to vote.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HowItWorks;